import { render, staticRenderFns } from "./BucketListModal.vue?vue&type=template&id=27455987&"
import script from "./BucketListModal.vue?vue&type=script&lang=js&"
export * from "./BucketListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports